import * as Joi from 'joi';

const { boolean, string } = Joi.types();

export const sentryConfigSchema = Joi.object({
  enabled: boolean.empty('').truthy('true').falsy('false').default(false),
  dsn: string
    .when('enabled', {
      is: true,
      // biome-ignore lint/suspicious/noThenProperty: Joi when() condition, not a thenable
      then: string.uri().required(),
      otherwise: string.optional(),
    })
    .required(),
  env: string
    .when('enabled', {
      is: true,
      // biome-ignore lint/suspicious/noThenProperty: Joi when() condition, not a thenable
      then: string.required(),
      otherwise: string.optional(),
    })
    .required(),
  traceSampleRate: Joi.number().min(0).max(1).default(0.1),
  replaysSessionSampleRate: Joi.number().min(0).max(1).default(0.05),
  replaysOnErrorSampleRate: Joi.number().min(0).max(1).default(0.5),
});
